module.exports = __webpack_public_path__ + "assets/svg/Icons/32/time-green-c00c79.svg";